<script>
	import { onDestroy, onMount } from 'svelte';
	import { tweened } from 'svelte/motion';
	import { cubicOut } from 'svelte/easing';
//	import navigationState from '../stores/navigationState';
    import { navigating } from '$app/stores';
    import { writable } from 'svelte/store';
    import { get } from 'svelte/store';

    let timerId = null;

    const progress = writable(0);

    /*
    const progress_tw = tweened(0, {
		duration: 400,
		easing: cubicOut
	});
    */

    function crawl() {
        if($navigating) {    
            ///console.log("navigating from: "+$navigating.from.url.pathname+" to: "+$navigating.to.url.pathname+" progress="+$progress+" progress_tw="+$progress_tw);
            //progress.update(current => (current+1) / 2);

            //console.log(`progress=${get(progress)}`);
            progress.update(current => current + (0.9-current)/3);
            //console.log(`new progress=${get(progress)}`);

            ///progress_tw.set($progress);
            ///console.log("new progress="+$progress+" progress_tw="+$progress_tw);
            timerId = setTimeout(crawl, 100);
        } else {
            if(timerId) 
                clearTimeout(timerId);
            /////console.log("progress_tw was="+$progress_tw+", setting to=1");
            //progress_tw.set(1);
        }
    }

    //$: console.log(get(progress));

	/*const unsubscribe = navigationState.subscribe((state) => {
		if (state === 'loaded') {
			progress.set(1, { duration: 1000 });
		}
	});*/
    
	onMount(() => {
		//progress.set(0.5)
        //crawl();
        timerId = setTimeout(crawl, 40 /*200*/);
	});
	onDestroy(() => {
        if(timerId) 
            clearTimeout(timerId);
        //progress.set(1);
		//unsubscribe();
	});
</script>


<div class="progress-bar">
	<!--div class="progress-sliver has-background-grey-light" style={`--width: ${$progress * 100}%`} /-->
	<div class="progress-sliver" style={`--width: ${$progress * 100}%`}></div>
</div>

<style>
	.progress-bar {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		/*height: 0.25rem;*/
        height: 2px;
        z-index: 99;
        /*background-color: #dddddd;*/
	}
	.progress-sliver {
		width: var(--width);
		background-color: #f8485e;
		height: 100%;
	}
</style>
